import { render, staticRenderFns } from "./stock-warehouse.vue?vue&type=template&id=4b712124&"
import script from "./stock-warehouse.vue?vue&type=script&lang=ts&"
export * from "./stock-warehouse.vue?vue&type=script&lang=ts&"
import style0 from "./stock-warehouse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports